import React from 'react'
import moment from 'moment'

export default ({ community, inverted }) => (
  <span className={`${inverted ? 'white' : 'text-dim'} text-small`}>
    Created {moment(community.createdAt).format('l')}
  </span>
)
